<template>
	<div class='grid select-value-block'>

		<div :class='{ "not-match": mzlIsNotMatch }'>
			<div>СОМ</div>
			<div class='mzl-input-container'>
				<VSelect
					v-model='mzlValue'
					:options='manualMzlList'
					:disabled='disabled || !actLpoIsDraft'
					class='mzl-input'
				/>

				<!-- <button @click='getMzlFull'><i class='fa fa-sync-alt'></i></button> -->
			</div>

		</div>

		<b-button v-if='mzlIsNotMatch' @click='saveManualMzl' :disabled='!actLpoIsDraft'>сохранить мероприятие</b-button>

	</div>
</template>

<script>

import { mapState, mapActions } from 'vuex';

export default {
	name: 'InspectionMzlSom',

	data: () => ({
		chva: false,
		mzlValue: null,
		noNeedMzl: false,

		list: [
			{
				id: '512',
				name: 'ВСР' 
			}
		]
	}),

	computed: {
		actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

		isVsrAuto() {
			if (!this.isManual && this.mzl && this.mzl.id === '512') {
				return true;
			}
			return false;
		},

		mzlIsNotMatch() {
			if (!this.isManual) {
				return false;
			}

			if (this.mzlValue && this.manualMzl) {
				if (this.mzlValue.id === this.manualMzl.mzl_id) {
					return false;
				} else {
					return true;
				}
			} else if (!this.mzlValue && this.manualMzl) {
				return true;
			} else if (this.mzlValue && !this.manualMzl) {
				return true;
			} else if (!this.mzlValue && !this.manualMzl) {
				return false;
			}

			return false;
		},

		isManual() {
			return this.mzl && this.mzl.id === '-1';
		},

		disabled() {
			// return !this.mzl || !this.isManual;
		},

		...mapState('selectedLpo', {
			mzl: state => state.mzl.mzl,
			manualMzl: state => state.mzl.manualMzl,
			manualMzlList: state => state.mzl.manualMzlList,
			mzlIsLoading: state => state.mzl.mzlIsLoading
		})
	},

	methods: {
		noNeedChanged(event) {
			// const checked = event.target.checked;

			// console.log(this.noNeedMzl);

			this.toggleNoNeed(this.noNeedMzl).then(res => {
				return this.getMzlFull();
			})
		},

		saveManualMzl() {
			if (this.mzlValue) {

				// if (this.manualMzl)

				// this.removeManualMzl(this.manualMzl.id).then(res => {
					// return this.getMzlFull();
				// })

				this.s_saveManualMzl(this.mzlValue.id).then(res => {
					return this.getMzlFull();
				});
			} else {
				this.removeManualMzl(this.manualMzl.id).then(res => {
					return this.getMzlFull();
				})
			}

			
		},

		getMzlFull() {

			this.s_getMzlFull().then(res => {
				console.log('mzl: ', this.mzl);
				console.log('manual mzl: ', this.manualMzl);
				console.log('manual mzl list: ', this.manualMzlList);

				/* если ручной ввод */
				if (this.isManual) {
					if (this.manualMzl) {
						const option = {
							id: this.manualMzl.mzl_id,
							name: this.manualMzl.mzl_name
						};
						this.mzlValue = option;
					} 
				} else { /* если автоматически */
					this.mzlValue = JSON.parse(JSON.stringify(this.mzl));
				}
			});

		},

		...mapActions('selectedLpo', [
			'getMzl',
			'getManualMzl',
			'getManualMzlList',
			'removeManualMzl',
			'toggleNoNeed'
		]),
		...mapActions('selectedLpo', {
			s_getMzlFull: 'getMzlFull',
			s_saveManualMzl: 'saveManualMzl'
		})
	},

	mounted() {
		this.getMzlFull();
	}

};

</script>

<style scoped src='@/style/grid.css'></style>

<style scoped>
	.mzl-input-container {
		display: flex;
		/*align-items: center;*/
	}

	.mzl-input {
		flex: 1;
	}

	.mzl-no-need-container {
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.not-match {
		background-color: orange;
	}

	.grid {
		align-items: center;
	}
</style>